"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report to PostHog so we can see the actual exception on production.
    try {
      // posthog may not be loaded yet — dynamic import so this doesn't
      // block rendering or throw if the bundle failed to load.
      import("posthog-js").then(({ default: posthog }) => {
        posthog.captureException(error, {
          source: "global-error-boundary",
          digest: error.digest ?? null,
          ua: typeof navigator !== "undefined" ? navigator.userAgent : null,
          pathname:
            typeof window !== "undefined" ? window.location.pathname : null,
        });
      });
    } catch {
      /* posthog not available */
    }
    // Always log so Safari Web Inspector picks it up.
    console.error("[GlobalError]", error);
  }, [error]);

  return (
    <html lang="ro">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, sans-serif",
          background: "#FFF9F5",
          color: "#264653",
          padding: "1.5rem",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 480 }}>
          <h1 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: "0.75rem" }}>
            Ceva n-a mers
          </h1>
          <p style={{ fontSize: "0.9rem", opacity: 0.7, marginBottom: "1.5rem" }}>
            A apărut o eroare neașteptată. Poți reîncerca sau reveni pe pagina principală.
          </p>
          {process.env.NODE_ENV !== "production" && (
            <pre
              style={{
                background: "#fee2e2",
                color: "#991b1b",
                padding: "0.75rem",
                borderRadius: "0.5rem",
                fontSize: "0.75rem",
                textAlign: "left",
                overflowX: "auto",
                marginBottom: "1.5rem",
              }}
            >
              {error.message}
              {error.digest ? `\n\ndigest: ${error.digest}` : ""}
            </pre>
          )}
          <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={reset}
              style={{
                padding: "0.6rem 1.25rem",
                background: "#2C969B",
                color: "#fff",
                border: "none",
                borderRadius: "999px",
                fontWeight: 600,
                fontSize: "0.9rem",
                cursor: "pointer",
              }}
            >
              Reîncearcă
            </button>
            <a
              href="/"
              style={{
                padding: "0.6rem 1.25rem",
                background: "transparent",
                color: "#264653",
                border: "1px solid rgba(38,70,83,0.25)",
                borderRadius: "999px",
                fontWeight: 600,
                fontSize: "0.9rem",
                textDecoration: "none",
              }}
            >
              Pagina principală
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
